import get from 'lodash/get';
import featureFlags from '@/store/modules/featureFlags';
import Metrics from './Metrics.vue';
import Platform from './Platform/Platform.router';
import Customers from './Customers/Customers.router';
import Campaign from './Campaign/Campaign.router';
import Agents from './Agents/Agents.router';
import Insights from './Insights/Insights.router';
import Assist from './Assist/Assist.router';
import AiMetrics from './SmartAssist/SmartAssist.router';

const showAiMetrics = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_AI_METRICS', false);
const showCampaignMetrics = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_CAMPAIGN_METRICS', false);

const rootRoute = {
  path: '/metrics',
  name: 'Metrics',
  component: Metrics,
  meta: {
    auth: true,
  },
};
const childRoutes =
  [
    Platform,
    Customers,
    Agents,
    Insights,
    Assist,
    ...(showAiMetrics ? [AiMetrics] : []),
    ...(showCampaignMetrics ? [Campaign] : []),
  ];

export default {
  ...rootRoute,
  children: childRoutes,
};
